export default __webpack_public_path__ + "media/assets/fonts/081_font_iom-070bb12bc30f1af9c9a4f6ae0dd891c7.svg";